import { defineDomainTranslations } from './defineDomainTranslations';

const en = {
  'acquisitionSurvey.otherPlaceholder': 'Tell us where',
  'acquisitionSurvey.question': 'How did you hear about Rask?',
  'acquisitionSurvey.skip': 'Skip',
  'acquisitionSurvey.source.blogger': 'Creator or blogger',
  'acquisitionSurvey.source.chatgpt': 'ChatGPT',
  'acquisitionSurvey.source.friend': 'Colleague or friend',
  'acquisitionSurvey.source.google': 'Google search',
  'acquisitionSurvey.source.instagramFacebook': 'Instagram or Facebook',
  'acquisitionSurvey.source.linkedin': 'LinkedIn',
  'acquisitionSurvey.source.other': 'Other',
  'acquisitionSurvey.source.otherAi': 'Claude and other AI',
  'acquisitionSurvey.source.tiktok': 'TikTok',
  'acquisitionSurvey.source.x': 'X (Twitter)',
  'acquisitionSurvey.source.youtube': 'YouTube',
  'acquisitionSurvey.submit': 'Continue',
} as const;

type AcquisitionSurveyTranslation = Record<keyof typeof en, string>;

const es = {
  'acquisitionSurvey.otherPlaceholder': 'Cuéntanos dónde',
  'acquisitionSurvey.question': '¿Cómo conociste Rask?',
  'acquisitionSurvey.skip': 'Omitir',
  'acquisitionSurvey.source.blogger': 'Creador o bloguero',
  'acquisitionSurvey.source.chatgpt': 'ChatGPT',
  'acquisitionSurvey.source.friend': 'Colega o amigo',
  'acquisitionSurvey.source.google': 'Búsqueda en Google',
  'acquisitionSurvey.source.instagramFacebook': 'Instagram o Facebook',
  'acquisitionSurvey.source.linkedin': 'LinkedIn',
  'acquisitionSurvey.source.other': 'Otro',
  'acquisitionSurvey.source.otherAi': 'Claude y otras IA',
  'acquisitionSurvey.source.tiktok': 'TikTok',
  'acquisitionSurvey.source.x': 'X (Twitter)',
  'acquisitionSurvey.source.youtube': 'YouTube',
  'acquisitionSurvey.submit': 'Continuar',
} satisfies AcquisitionSurveyTranslation;

const pt = {
  'acquisitionSurvey.otherPlaceholder': 'Conte para a gente onde você conheceu a Rask',
  'acquisitionSurvey.question': 'Como você conheceu a Rask?',
  'acquisitionSurvey.skip': 'Pular',
  'acquisitionSurvey.source.blogger': 'Criador ou blogueiro',
  'acquisitionSurvey.source.chatgpt': 'ChatGPT',
  'acquisitionSurvey.source.friend': 'Colega ou amigo',
  'acquisitionSurvey.source.google': 'Pesquisa no Google',
  'acquisitionSurvey.source.instagramFacebook': 'Instagram ou Facebook',
  'acquisitionSurvey.source.linkedin': 'LinkedIn',
  'acquisitionSurvey.source.other': 'Outro',
  'acquisitionSurvey.source.otherAi': 'Claude e outras IAs',
  'acquisitionSurvey.source.tiktok': 'TikTok',
  'acquisitionSurvey.source.x': 'X (Twitter)',
  'acquisitionSurvey.source.youtube': 'YouTube',
  'acquisitionSurvey.submit': 'Continuar',
} satisfies AcquisitionSurveyTranslation;

const fr = {
  'acquisitionSurvey.otherPlaceholder': 'Précisez où vous avez connu Rask',
  'acquisitionSurvey.question': 'Comment avez-vous connu Rask ?',
  'acquisitionSurvey.skip': 'Passer',
  'acquisitionSurvey.source.blogger': 'Créateur ou blogueur',
  'acquisitionSurvey.source.chatgpt': 'ChatGPT',
  'acquisitionSurvey.source.friend': 'Collègue ou ami',
  'acquisitionSurvey.source.google': 'Recherche Google',
  'acquisitionSurvey.source.instagramFacebook': 'Instagram ou Facebook',
  'acquisitionSurvey.source.linkedin': 'LinkedIn',
  'acquisitionSurvey.source.other': 'Autre',
  'acquisitionSurvey.source.otherAi': 'Claude et d’autres IA',
  'acquisitionSurvey.source.tiktok': 'TikTok',
  'acquisitionSurvey.source.x': 'X (Twitter)',
  'acquisitionSurvey.source.youtube': 'YouTube',
  'acquisitionSurvey.submit': 'Continuer',
} satisfies AcquisitionSurveyTranslation;

const it = {
  'acquisitionSurvey.otherPlaceholder': 'Dicci dove',
  'acquisitionSurvey.question': 'Come hai conosciuto Rask?',
  'acquisitionSurvey.skip': 'Salta',
  'acquisitionSurvey.source.blogger': 'Creator o blogger',
  'acquisitionSurvey.source.chatgpt': 'ChatGPT',
  'acquisitionSurvey.source.friend': 'Collega o amico',
  'acquisitionSurvey.source.google': 'Ricerca Google',
  'acquisitionSurvey.source.instagramFacebook': 'Instagram o Facebook',
  'acquisitionSurvey.source.linkedin': 'LinkedIn',
  'acquisitionSurvey.source.other': 'Altro',
  'acquisitionSurvey.source.otherAi': 'Claude e altre IA',
  'acquisitionSurvey.source.tiktok': 'TikTok',
  'acquisitionSurvey.source.x': 'X (Twitter)',
  'acquisitionSurvey.source.youtube': 'YouTube',
  'acquisitionSurvey.submit': 'Continua',
} satisfies AcquisitionSurveyTranslation;

const ru = {
  'acquisitionSurvey.otherPlaceholder': 'Расскажите, где именно',
  'acquisitionSurvey.question': 'Как вы узнали о Rask?',
  'acquisitionSurvey.skip': 'Пропустить',
  'acquisitionSurvey.source.blogger': 'Автор контента или блогер',
  'acquisitionSurvey.source.chatgpt': 'ChatGPT',
  'acquisitionSurvey.source.friend': 'Коллега или друг',
  'acquisitionSurvey.source.google': 'Поиск в Google',
  'acquisitionSurvey.source.instagramFacebook': 'Instagram или Facebook',
  'acquisitionSurvey.source.linkedin': 'LinkedIn',
  'acquisitionSurvey.source.other': 'Другое',
  'acquisitionSurvey.source.otherAi': 'Claude и другие ИИ-инструменты',
  'acquisitionSurvey.source.tiktok': 'TikTok',
  'acquisitionSurvey.source.x': 'X (Twitter)',
  'acquisitionSurvey.source.youtube': 'YouTube',
  'acquisitionSurvey.submit': 'Продолжить',
} satisfies AcquisitionSurveyTranslation;

export const ACQUISITION_SURVEY_TRANSLATIONS = defineDomainTranslations({ en, es, fr, it, pt, ru });
